export default {
  header: "让科技改变你与知识链接的方式",
  headerDesc:
    "海马超记，一款备考效率提升神器。操作简易，功能强大，让你用更少的时间，更快速地，达成目标，用更优的方式，更高效地记忆知识。",
  // headerDesc: [
  //   "海马超记，一款备考效率提升神器。操作简易，功能强大，让你用更少的时间，",
  //   "更快速地，达成目标，用更优的方式，更高效地记忆知识。",
  // ],
  action: [
    {
      flexDirection: "row",
      color: "#FA9A6B",
      title: "你拥有惊人脑力，我们解决其余问题",
      desc: "你的脑力应该被更合理地利用。海马超记通过智能算法，筛选需要被你间隔重复记忆的知识，精准推送个性化学习内容，帮你开启深层记忆回路，更合理地分配学习时间和精力，用工具助你征服考试。",
    },
    {
      flexDirection: "row-reverse",
      color: "#B2A0FF",
      title: "你的学习目标，可以科学分解成多个知识闪卡",
      desc: "你每天的学习都应该带来进步与成就。海马超记将学习科目解构成小知识点，用简单的形式呈现在卡片上，让你随时随地学习知识。当每天所获给你带来胜利喜悦时，你就能坚持下去。",
    },
    {
      flexDirection: "row",
      color: "#47A4DF",
      title: "制定专属学习计划，你的成功指日可待",
      desc: "你可以根据自己的需求制定学习计划。海马超记能够适配你的学习需求、学习方式和学习偏好。帮助你更快达成备考目标。",
    },
    {
      flexDirection: "row-reverse",
      color: "#FF7E5F",
      title: "与更多的学习者一起，共建优质学习资源平台",
      desc: "你既是学习者，也是优质学习资源的创造者，分享者。海马超记致力于打造一个精彩的学习社区，把“你”和更多的“他（她）”链接在一起，一起分享丰富的学习内容和学习经验，互相激励、共同成长，携手完成学习目标。",
    },
  ],
  feedbackTitle: "来自更多海马超记学习者的使用反馈",
  feedbacks: [
    {
      background: "#FFB886",
      content:
        "“海马超记帮助我解放了自己的学习压力，让我更从容的应对即将到来的考试。”",
      user: "@Jinlin",
    },
    {
      background: "#B2A0FF",
      content:
        "“原来一直靠拿着书本死记硬背的方式学习，海马超记给了我一种全新的学习体验。”",
      user: "@Jeason Lee",
    },
    {
      background: "#47A4DF",
      content:
        "“海马超记真的很好用，现在每天空闲的时间都会打开手机刷一刷，没什么负担的同时也记住了要记住的内容。”",
      user: "@鸣",
    },
    {
      background: "#FF7E5F",
      content:
        "“强烈安利！已经介绍身边备考的很多同学在一起用了，反馈都非常好！”",
      user: "@Zheng_Zander",
    },
    {
      background: "#ACE100",
      content:
        "“海马超记界面看起来很舒服，已有的内容也非常好，新手使用完全没有任何障碍。”",
      user: "@爱学习的小刘",
    },
  ],
  expect: "期待开启一趟更“有趣”的学习之旅吗？",
  use: "免费试用/无强制收费，扫码现在就开始学习",
  version: "@2022 深圳市原点未来科技有限公司   ",
  versionbeian: "粵ICP备2022062693号-1",
  extra: "公众号、微博、小红书搜索“海马超记”  关注更多动态",
};
